<template>
  <header id="header">
    <div
      class="header-container tw-flex tw-items-center tw-justify-between tw-fixed xl:tw-w-full tw-px-6 tw-bg-white tw-border-b tw-border-[#E2E8F0] tw-h-20 tw-z-20"
    >
      <!-- Left side: Back button or Welcome text -->
      <div class="tw-hidden md:tw-flex tw-items-center md:tw-ml-20 xl:tw-ml-0">
        <div v-if="backButtonConfig" class="tw-flex tw-items-center tw-gap-4">
          <button
            @click="goBack"
            class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-bg-[#F1F5F9] hover:tw-bg-[#E2E8F0] tw-transition-colors tw-duration-200"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#334155"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M19 12H5"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
          <h2 class="tw-text-lg tw-font-semibold tw-text-[#001240]">{{ backButtonConfig.title }}</h2>
        </div>
        <WelcomeText v-else />
      </div>

      <!-- Right side: Profile -->
      <HeaderProfile />
    </div>
  </header>
</template>

<script>
import HeaderProfile from "@/components/navigation/header/HeaderProfile.vue";
import WelcomeText from "@/components/navigation/header/WelcomeText.vue";
import { computed } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "Header",
  components: {
    HeaderProfile,
    WelcomeText,
  },
  setup() {
    const router = useRouter();

    const backButtonRoutes = [
      {
        path: "/dashboard/teams/create-role",
        backTo: "/dashboard/teams",
        title: "Create new role",
      },
      {
        path: "/dashboard/teams/edit-role",
        backTo: "/dashboard/teams",
        title: "Edit role",
      },
    ];

    const backButtonConfig = computed(() => {
      const currentPath = router.currentRoute.value.path;

      return backButtonRoutes.find((route) => {
        return (
          currentPath.startsWith(route.path) &&
          (currentPath.length === route.path.length ||
            currentPath.charAt(route.path.length) === "/")
        );
      });
    });

    const goBack = () => {
      if (backButtonConfig.value) {
        router.push(backButtonConfig.value.backTo);
      }
    };

    return {
      backButtonConfig,
      goBack,
    };
  },
};
</script>

<style lang="scss" scoped>
#header {
  .header-container {
    width: 100%;
    @media screen and (min-width: 1280px) {
      width: calc(100% - #{$side-bar-width});
    }
  }
}
</style>